'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = bubble;
exports.hideImmediately = hideImmediately;
exports.cleanup = cleanup;
exports.posX = posX;
exports.posY = posY;

var _defs = require('./defs');

var _audio = require('./audio');

var _audio2 = _interopRequireDefault(_audio);

var _content = require('./content');

var _content2 = _interopRequireDefault(_content);

var _assign = require('./assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var bubbleElement = void 0;
var hideTimeout = void 0;
var showTimeout = void 0;
var showing = false;
var bubbles = 0;

function bubble() {
  ++bubbles;

  if (!bubbleElement) {
    bubbleElement = (0, _content.div)({
      style: _content.bubbleStyle
    }, (0, _content.div)(), // placeholder for content
    (0, _content.div)({
      style: _content.arrowStyle
    }));
    document.body.appendChild(bubbleElement);
    document.body.addEventListener('mouseover', hover, false);
    bubbleElement.addEventListener('click', click, false);
    bubbleElement.addEventListener('mouseover', bubbleHover, false);
  }

  return function () {
    --bubbles;

    if (bubbles <= 0) {
      cleanup();
    }
  };
}

function hideImmediately() {
  showing = false;

  if (bubbleElement) {
    bubbleElement.addEventListener('transitionend', removeAfterHide, false);
    (0, _assign2["default"])(bubbleElement.style, {
      opacity: '0'
    }, _content.bubbleTransitionOpacity);
  }
}

function removeAfterHide() {
  if (bubbleElement) {
    bubbleElement.removeEventListener('transitionend', removeAfterHide, false);
    (0, _assign2["default"])(bubbleElement.style, {
      display: 'none',
      left: '',
      top: ''
    });
  }
}

function cleanup() {
  cancelHide();
  document.body.removeEventListener('mouseover', hover, false);
  bubbleElement.removeEventListener('click', click, false);
  bubbleElement.removeEventListener('mouseover', bubbleHover, false);
  document.body.removeChild(bubbleElement);
  bubbleElement = undefined;
  bubbles = 0;
}

function hover(_ref) {
  var target = _ref.target;

  if (detectBrowserExtension()) {
    cancelHide();
    cancelShow();
    hideImmediately();
  } else if (target.className === _defs.POPUP_CLASS) {
    cancelHide();

    if (showing) {
      showImmediately(target);
    } else {
      show(target);
    }
  } else if (target === bubbleElement) {
    cancelShow();
    cancelHide();
  } else {
    hide();
  }
}

function detectBrowserExtension() {
  return !!document.querySelector('.iknow-qtip');
}

function click(_ref2) {
  var target = _ref2.target;
  var sound = target.getAttribute('data-sound');

  if (!sound) {
    return;
  }

  (0, _audio2["default"])(sound);
}

function bubbleHover(event) {
  // This, when called directly on the bubble element mouseover
  // listener will stop mouseover event propagating to parents so that
  // hide will not be called
  event.stopPropagation();
  cancelHide();
  var target = event.target;

  if (target.className === _defs.BUTTON_CLASS) {
    highlight(target);
  }
}

function cancelHide() {
  clearTimeout(hideTimeout);
}

function cancelShow() {
  clearTimeout(showTimeout);
}

function hide() {
  cancelHide();
  cancelShow();

  if (showing) {
    hideTimeout = setTimeout(hideImmediately, _defs.HIDE_DELAY);
  }
}

function show(source) {
  cancelShow();
  showTimeout = setTimeout(showImmediately.bind(null, source), _defs.SHOW_DELAY);
}

function showImmediately(source) {
  var slide = showing;
  showing = true;
  var fixed = isFixed(source);
  var scrollX = fixed ? 0 : window.scrollX || window.pageXOffset;
  var scrollY = fixed ? 0 : window.scrollY || window.pageYOffset;
  var word = source.childNodes[0].wholeText; // To allow sizing calculations the bubble needs to have content in
  // and be displayed

  bubbleElement.replaceChild((0, _content2["default"])(word), bubbleElement.children[0]);
  (0, _assign2["default"])(bubbleElement.style, {
    display: 'block',
    position: 'fixed',
    visibility: 'hidden',
    opacity: '0'
  }, slide ? _content.bubbleTransitionSliding : _content.bubbleTransitionOpacity);
  var sourceBounds = source.getBoundingClientRect();
  var bubbleBounds = bubbleElement.getBoundingClientRect();

  var _posX = posX(sourceBounds, bubbleBounds, scrollX, window.innerWidth);

  var x = _posX.x;
  var arrowX = _posX.arrowX;

  var _posY = posY(sourceBounds, bubbleBounds, scrollY);

  var y = _posY.y;
  var arrowUp = _posY.arrowUp;
  var arrowChanges = (0, _assign2["default"])({
    left: bubbleBounds.width / 2 + arrowX + 'px'
  }, arrowUp ? {
    borderWidth: '1px 0 0 1px',
    top: '-10px',
    bottom: ''
  } : {
    borderWidth: '0 1px 1px 0',
    top: '',
    bottom: '0'
  });
  (0, _assign2["default"])(bubbleElement.children[1].style, arrowChanges);
  (0, _assign2["default"])(bubbleElement.style, {
    visibility: 'visible',
    opacity: '1',
    position: fixed ? 'fixed' : 'absolute',
    left: x + 'px',
    top: y + 'px'
  });
}

function constrain(min, max, value) {
  return Math.min(max, Math.max(value, min));
}

function posX(sourceBounds, bubbleBounds, scrollX, windowWidth) {
  // Absolute middle point of the word we're displayig the bubble for
  var middleOfSource = scrollX + sourceBounds.left + sourceBounds.width / 2; // Minimum value where bubble doesn't dissapear behind left edge

  var minX = scrollX; // Maximum value where bubble will be visible on right edge

  var maxX = scrollX + windowWidth - bubbleBounds.width; // Position bubble in the center relative to the middleOfSource
  // maxX >= middle point >= minX

  var x = constrain(minX, maxX, middleOfSource - bubbleBounds.width / 2); // arrowX is a value relative to middle of the bubble so it'll be 0
  // in the middle and +/- if adjustment is needed (bubble is on left
  // or right edge)

  var maxArrowOffset = bubbleBounds.width / 2 - _defs.ARROW_SAFETY_MARGIN;
  var arrowX = constrain(-maxArrowOffset, maxArrowOffset, middleOfSource - x - bubbleBounds.width / 2);
  return {
    x: x,
    arrowX: arrowX
  };
}

function posY(sourceBounds, bubbleBounds, scrollY) {
  // Adds 6px space for the arrow
  var y = scrollY + sourceBounds.top - bubbleBounds.height - 6;
  var arrowUp = false; // If y falls above top screen edge put the bubble under the source
  // element and face the arrow up

  if (y < scrollY) {
    y = scrollY + sourceBounds.top + sourceBounds.height + 6;
    arrowUp = true;
  }

  return {
    y: y,
    arrowUp: arrowUp
  };
}

function isFixed(element) {
  // For non-fixed elements, top-most offsetParent is the body because
  // they're positioned relatively to body. For fixed elements it's
  // the fixed element itself.
  var node = element;

  while (node.offsetParent) {
    node = node.offsetParent;

    if (node === document.body) {
      return false;
    }
  }

  return true;
}

function highlight(target) {
  // This rule is necessary for this function to work

  /* eslint no-param-reassign: 0 */
  target.addEventListener('mouseout', downlight, false);
  target.style.opacity = '1';

  function downlight() {
    target.removeEventListener('mouseout', downlight, false);
    target.style.opacity = _defs.BUTTON_RESTING_OPACITY;
  }
}